<template>
    <div class="branch-search">
        <div class="main-content clearfix">
            <el-form :inline="true" class="demo-form-inline fr">
                <img src="../assets/images/branch-tel.png" alt="" class="tel-img">
                <span class="fs18">{{tel}}</span>
                <el-form-item class="search-input">
                    <!-- @blur 是解决elementUI Input 输入框在IE9 清空后获取不到再次输入的值,但是这个网站要求清空输入框写不写都可以 -->
                    <el-input  @keyup.enter.native="onSubmit($event)" v-model="formInline.searchValue" @blur="formInline.searchValue = changeValue($event)"></el-input>
                    <input type="text" style="display:none;">
                    <img src="../assets/images/branch-search.png" alt="" class="search-icon" @click="onSubmit">
                </el-form-item>        
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        searchValue:{
            type:String,
            default:()=>{}
        },
    },
    data() {
        return {
            formInline:{
                searchValue:'',
            },
            short_name:this.$route.params.short_name,
        };
    },
    computed: {
        tel(){
            return this.$store.getters.getGroupConfig.tel;
        }  
    },
    created() {
        //this.formInline.searchValue=this.searchValue||this.$route.query.search||'';//让输入框的搜索结果显示在输入框内
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        onSubmit(e) {
            if(e.target.value){
             this.formInline.searchValue=e.target.value;
            }

            if(this.formInline.searchValue == ''){
                this.formInline.searchValue = ' ';
            }

            if(this.$route.query.searchId == this.formInline.searchValue){
                this.$router.go(0);
            }else{
                this.$router.push('/search/'+this.$route.params.short_name+'/'+this.formInline.searchValue+'.html');
                this.formInline.searchValue=''//清空输入框内容
            }
        }
    },
    components: {

    },
};
</script>

<style scoped>
.branch-search{height:40px;background:#4A90E2; color:#fff;width:100%;line-height:40px;}
.tel-img{width:30px;height:40px;margin-right:8px;}
.search-input{margin-left:40px;}
.branch-search .demo-form-inline{height:40px;}
</style>
<style>
.branch-search .el-form--inline .el-form-item{margin-bottom:0;}
.branch-search .el-form-item__content{width:200px!important;line-height:24px;margin-top:8px;}
.branch-search .el-input__icon{line-height:24px;margin-top:8px;}
.branch-search .el-form-item__content .el-input{position: relative;}
.branch-search .el-form-item__content .search-icon{position:absolute;right:0;top:0;}
.branch-search .el-input__inner{width:200px;height:24px!important;border-radius:5px;border:1px solid #fff;line-height:24px;padding-left:10px;padding-right:30px;font-size:14px;color:#fff;background:transparent;}
.branch-search .el-input__inner:focus{border:1px solid #fff;}
</style>



// WEBPACK FOOTER //
// src/components/BranchSearch.vue